import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { message, Space, Tag, Popconfirm } from 'antd';
import styles from './style.less';
import { useRequest, request, useLocation } from 'umi';
import { useUpdateEffect } from 'ahooks';
import OKPlayer from '@/components/OKPlayer';
import { base64ToBlob, getElementSize } from '@/util';
import { SettingOutlined, SyncOutlined } from '@ant-design/icons';

let apiPrefix = 'https://open.mokan.cn';
const OKLive = () => {
  const location = useLocation();
  let {
    type,
    deviceId,
    serialNumber,
    timestamp,
    clientCode,
    sign,
    hideYun, //是否隐藏云台 有值的时候隐藏
    hideVoiceBtn, //隐藏声音控制 有值的时候隐藏
    talkback, //是否开启对讲  有值的时候显示
    text1, //第一行水印，如：项目经理：张三
    text2, //第二行水印，如：项目监理：李四
    text3, //第三行水印，如：地址：北京市西城区南大街135号
    setPresetPosition, //设置预置位
  } = location.query;
  const okPlayerRef = useRef();
  const [serialNum, setSerialNum] = useState(serialNumber);
  const [deviceInfo, setDeviceInfo] = useState(null); //设备信息
  const [showTag, setShowTag] = useState(false); // 有无预置位
  const hasYzw = setPresetPosition && setPresetPosition != 'false';
  const [openDefYZW, setOpenDefYZW] = useState(false); //默认预置位弹窗
  const [openDefLoading, setOpenDefLoading] = useState(false); //设置默认loading
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
  });
  const prevDimensionsRef = useRef();
  if (type === 'test') {
    apiPrefix = 'https://test-open.mokan.cn';
  }
  const tempObj = {};
  if (serialNumber) {
    tempObj.serialNumber = serialNumber;
  } else if (deviceId) {
    tempObj.deviceId = deviceId;
  }

  useEffect(() => {
    getDeviceInfo().then((res) => {
      setDeviceInfo(res.data);
      setSerialNum(res.data.serialNumber);
    });

    hasYzw &&
      _getYzw().then((res) => {
        setShowTag(!res.data);
      });
  }, []);
  function getDeviceInfo() {
    return request(`${apiPrefix}/openapi/ai/getDeviceInfo`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }
  function _setPtz(obj) {
    const objData = new FormData();
    for (const [key, value] of Object.entries(obj)) {
      objData.append(key, value);
    }
    return request(`${apiPrefix}/openapi/video/setDefaultPtz`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      data: objData,
    });
  }
  function _getYzw() {
    return request(`${apiPrefix}/openapi/video/getDefaultPtzStatus`, {
      method: 'get',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }
  // 复位
  function _goPlace() {
    return request(`${apiPrefix}/openapi/video/gotoDefaultPlace`, {
      method: 'post',
      headers: {
        timestamp,
        clientCode,
        sign,
      },
      params: tempObj,
    });
  }
  // 操作预置位
  const handleYZW = () => {
    setOpenDefLoading(true);
    okPlayerRef.current.capturePicture().then((data) => {
      const blob = base64ToBlob(data.data.base64, 'image/jpeg');
      if (blob) {
        let obj = {
          ...tempObj,
          img: blob,
        };
        _setPtz(obj)
          .then(() => {
            message.success('操作成功');
            setOpenDefLoading(false);
            setShowTag(false);
          })
          .catch(() => {
            setOpenDefLoading(false);
          });
      } else {
        message.success('请稍后重试');
      }
    });
  };
  const handleResize = () => {
    const size = getElementSize('imgBox');
    setDimensions(size);
  };
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={styles.container} id="imgBox">
      <div style={{ width: '100%', position: 'relative' }}>
        {showTag && (
          <Tag color="blue" className="yzw-tag">
            无预置位
          </Tag>
        )}
        <div
          className='text-box'
        >
          {serialNumber != 'null' && serialNumber != 'undefined' && (
            <div>{serialNumber}</div>
          )}
          {text1 != 'null' && text1 != 'undefined' && <div>{text1}</div>}
          {text2 != 'null' && text2 != 'undefined' && <div>{text2}</div>}
          {text3 != 'null' && text3 != 'undefined' && <div>{text3}</div>}
        </div>
        {serialNum && dimensions.width && dimensions.height && (
          <OKPlayer
            ref={okPlayerRef}
            serialNumber={serialNum}
            type={type}
            timestamp={timestamp}
            clientCode={clientCode}
            sign={sign}
            message={talkback} //是否开启对讲
            directional={hideYun}
            voice={hideVoiceBtn}
            dimensions={dimensions}
          />
        )}

        {hasYzw && (
          <Space
            className='yzw-box'
          >
            <Popconfirm
              open={openDefYZW}
              onOpenChange={(newOpen) => setOpenDefYZW(newOpen)}
              title="是否设置预置位，确认后将当前位置设置为预置位？"
              onConfirm={() => {
                handleYZW(true);
              }}
              okButtonProps={{ loading: openDefLoading }}
            >
              <span className="btn">
                <SettingOutlined /> 设置预置位
              </span>
            </Popconfirm>
            {showTag ? (
              <span
                className="btn"
                onClick={() => {
                  message.error('设备无预置位，请先设置');
                }}
              >
                <SyncOutlined /> 复位
              </span>
            ) : (
              <Popconfirm
                title="你确定回到预置位吗？"
                onConfirm={() => {
                  _goPlace().then(() => {
                    message.success('操作成功，正在回到预置位');
                  });
                }}
                okText="确定"
                cancelText="取消"
              >
                <span className="btn">
                  <SyncOutlined /> 复位
                </span>
              </Popconfirm>
            )}
          </Space>
        )}
      </div>
    </div>
  );
};

export default () => {
  return <OKLive />;
};
